import { Route, Routes } from 'react-router-dom'

import { DataGridSyncUrlManagerProvider } from '@/contexts/DataGridSyncUrlManagerContext'
import NavigateToError from '@/features/error/pages/NavigateToError'
import FlexBalanceIndex from '@/features/flexBalance/pages/FlexBalanceIndex'

export default function FlexBalanceRoutes() {
  return (
    <Routes>
      <Route
        element={
          <DataGridSyncUrlManagerProvider>
            <FlexBalanceIndex />
          </DataGridSyncUrlManagerProvider>
        }
        path="/"
      />
      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
